module.exports = __webpack_public_path__ + "img/4S-shop-r.e422b58f.png";